<nz-layout class="app-layout">
	<nz-sider class="menu-sidebar" nzCollapsible nzWidth="256px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
		[nzTrigger]="null">
		<div class="sidebar-logo">
			<img src="./assets/images/logo.png" alt="Guglielmo">
			<h1>IOT Devices Management</h1>
		</div>
		<ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
			<li *ngIf="helpers.role() === role.ADMIN || helpers.role() === role.VIEWER || helpers.role() === role.USER || helpers.role() === role.SUPER_ADMIN"
				nz-menu-item
				nz-tooltip
				nzTooltipPlacement="right"
				nzTooltipTitle="{{isCollapsed ? ('devices.title' | translate): ''}}"
				routerLink="/devices"
				nzMatchRouter>
				<span nz-icon nzType="wifi"></span>
				<span>{{'devices.title' | translate}}</span>
			</li>
			<li *ngIf="helpers.role() === role.ADMIN || helpers.role() === role.VIEWER || helpers.role() === role.USER || helpers.role() === role.SUPER_ADMIN"
				nz-menu-item
				nz-tooltip
				nzTooltipPlacement="right"
				nzTooltipTitle="{{isCollapsed ? ('monitoring.title' | translate): ''}}"
				routerLink="/monitoring"
				nzMatchRouter>
				<span nz-icon nzType="eye"></span>
				<span>{{'monitoring.title' | translate}}</span>
			</li>
			<li *ngIf="helpers.role() === role.ADMIN || helpers.role() === role.SUPER_ADMIN"
				nz-menu-item
				nz-tooltip
				nzTooltipPlacement="right"
				nzTooltipTitle="{{isCollapsed ? ('users.title' | translate): ''}}"
				routerLink="/users"
				nzMatchRouter>
				<span nz-icon nzType="user"></span>
				<span>{{'users.title' | translate}}</span>
			</li>
			<li *ngIf="helpers.role() === role.SUPER_ADMIN"
				nz-menu-item
				nz-tooltip
				nzTooltipPlacement="right"
				nzTooltipTitle="{{isCollapsed ? ('vpn.title' | translate): ''}}"
				routerLink="/vpn"
				nzMatchRouter>
				<span nz-icon nzType="branches"></span>
				<span>{{'vpn.title' | translate}}</span>
			</li>
		</ul>
	</nz-sider>
	<!-- <nz-sider [(nzCollapsed)]="isCollapsed" [nzTrigger]="null" nzCollapsible nzBreakpoint="sm"
		[nzCollapsedWidth]="sideBarWidth">
		<div style="background:#fff" class="text-center">
		</div>
		<div class="logo cursor-pointer" (click)="clickOnTrigger()" nz-popover nzPopoverPlacement="bottomLeft"></div>
		<ul nz-menu nzMode="inline" *ngIf="(_sidebarService.menu$ | async) as menu">
			<ng-container *ngFor="let item of menu.items">
				<ng-container *ngIf="!item.subMenu">
					<li nz-menu-item (click)="redirect(item.page)"
						[nzSelected]="item.page === getCurrentRootPath()? 'nzSelected': null">
						<i nz-icon nzType="{{item.icon}}"></i><span>{{item.translate | translate}}</span>
					</li>
				</ng-container>
				<ng-container *ngIf="item.subMenu">
					<li nz-submenu [nzOpen]="item.page === getCurrentRootPath()? 'nzOpen': null" nzIcon="{{item.icon}}"
						nzTitle="{{item.translate | translate}}">
						<ul>
							<li *ngFor="let subItem of item.subMenu" nz-menu-item (click)="redirect(subItem.page)"
								[nzSelected]="subItem.page === getCurrentPath()? 'nzSelected': null">
								<span>{{subItem.translate | translate}}</span>
							</li>
						</ul>
					</li>
				</ng-container>
			</ng-container>
		</ul>
	</nz-sider> -->
	<nz-layout>
		<nz-header>
			<div nz-row [nzGutter]="0">
				<div nz-col [nzSpan]="8">
					<div class="app-header">
						<span class="header-trigger" (click)="isCollapsed = !isCollapsed">
							<i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
						</span>
						<span class="header-trigger" (click)="toggleTheme()">
							<span nz-icon nzType="format-painter" nzTheme="outline"></span>
						</span>
					</div>
				</div>
				<div nz-col [nzSpan]="16" nzJustify="end">
					<ul nz-menu nzMode="horizontal" [nzSelectable]="false" class="text-end">
						<li nz-menu-item>
							<app-language-selector></app-language-selector>
						</li>
						<li nz-menu-item>
							<a (click)="logout()" nzType="primary"><i nz-icon nzType="logout" nzTheme="outline"></i>
								Logout</a>
						</li>
					</ul>
				</div>
			</div>
		</nz-header>
		<nz-content>
			<div class="inner-content">
				<router-outlet></router-outlet>

			</div>
		</nz-content>
		<app-version></app-version>
	</nz-layout>
</nz-layout>